var _mask, _g, _path, _mask2, _g2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNotifications = function SvgIconNotifications(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.487H15.78V15.221H0V1.487Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.939 13.835H13.84C13.043 12.983 12.378 11.235 12.378 7.77299C12.378 4.653 10.518 3.451 8.958 2.991C8.956 2.991 7.935 2.721 6.869 2.995C5.285 3.445 3.401 4.64 3.401 7.77299C3.401 10.783 2.91 12.812 1.938 13.835H1.939ZM15.113 15.221H0.668004C0.578615 15.2194 0.490412 15.2003 0.408441 15.1646C0.32647 15.1289 0.252341 15.0774 0.190296 15.013C0.12825 14.9487 0.0795067 14.8727 0.0468542 14.7895C0.0142018 14.7062 -0.00171859 14.6174 4.20464e-06 14.528V13.843C4.20464e-06 13.532 0.200004 13.259 0.489004 13.176C0.963004 13.039 2.067 12.238 2.067 7.77299C2.067 3.549 4.86 2.127 6.526 1.656L6.54 1.652C7.955 1.287 9.258 1.64 9.313 1.656C10.963 2.141 13.713 3.57799 13.713 7.77299C13.713 12.405 14.908 13.076 15.275 13.171C15.4215 13.2116 15.5505 13.2995 15.6419 13.4211C15.7332 13.5426 15.7818 13.691 15.78 13.843V14.528C15.7817 14.6173 15.7658 14.7061 15.7333 14.7892C15.7007 14.8724 15.652 14.9483 15.5901 15.0127C15.5281 15.077 15.4541 15.1285 15.3723 15.1643C15.2904 15.2 15.2023 15.2193 15.113 15.221V15.221Z",
    fill: "#B0B5C4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 19.2H7.999C6.572 19.2 5.421 18.262 5.135 16.867C5.09567 16.6816 5.13104 16.4881 5.23345 16.3286C5.33585 16.1691 5.49703 16.0564 5.682 16.015C5.86658 15.9782 6.05822 16.0162 6.2148 16.1207C6.37137 16.2251 6.48007 16.3874 6.517 16.572C6.697 17.449 7.427 17.76 7.999 17.76C8.572 17.76 9.304 17.449 9.484 16.572C9.50204 16.4805 9.53798 16.3934 9.58976 16.3159C9.64155 16.2383 9.70814 16.1717 9.78574 16.12C9.86333 16.0682 9.95038 16.0323 10.0419 16.0143C10.1334 15.9963 10.2276 15.9965 10.319 16.015C10.5038 16.0566 10.6647 16.1694 10.7669 16.3289C10.8691 16.4884 10.9044 16.6817 10.865 16.867C10.579 18.263 9.427 19.2 7.999 19.2",
    fill: "#B0B5C4"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 2,
    height: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33401 0.164993H8.80701V2.96499H7.33401V0.164993Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07001 2.96499C7.66401 2.96499 7.33401 2.62199 7.33401 2.19799V0.932993C7.33401 0.508993 7.66401 0.164993 8.07101 0.164993C8.47801 0.164993 8.80701 0.508993 8.80701 0.932993V2.19799C8.80701 2.62199 8.47701 2.96499 8.07101 2.96499",
    fill: "#B0B5C4"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNotifications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-notifications.889f4b05.svg";
export { ForwardRef as ReactComponent };